<template>
  <div class="narrow-container mx-2">
    <div class="mt-6 mx-4" v-if="!loading">
      <div class="PolicyList px-4 mb-2" v-for="policy in policyList">
        <div class="d-flex py-4 align-center">
          <div
            class="PolicyList__icon-button pa-2"
            :class="{ 'mr-5': !isNavDrawerMiniVariant }"
          >
            <the-icon icon="document" class="PolicyList__icon" />
          </div>
          {{ policy.name }}
        </div>

        <v-btn
          class="v-btn viewBtn"
          @click="toPolicyDetail(policy)"
          elevation="2"
          large
        >
          <v-icon dark left> mdi-eye </v-icon>
          View
        </v-btn>
      </div>
    </div>
    <div v-else class="spinner">
      <FlamePreloader :compact="true" :size="100" />
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import FlamePreloader from '@/components/_Common/FlamePreloader'
import ColumnsFilter from '@/components/_Common/ColumnsFilter'
import { MODAL_ALERT } from '@/components/Modals'
import dayjs from 'dayjs'
import marketplaceAPI from '@/services/marketplace'

export default {
  name: 'PolicyList',
  components: {
    ColumnsFilter,
    FlamePreloader,
  },
  data() {
    return {
      loading: true,
      policyList: [],
    }
  },
  computed: {
    ...mapState({
      currentPublisherInfo: ({ publisher_infos }) => publisher_infos.current,
      isNavDrawerMiniVariant: ({ application }) =>
        application.isNavDrawerMiniVariant,
    }),
    isPublisherAdmin() {
      return this.currentPublisherInfo.role === 'admin'
    },
  },
  mounted() {
    this.getPolicyList()
  },
  methods: {
    async getPolicyList() {
      this.loading = true
      try {
        const policySets = await marketplaceAPI.listPolicySets({ active: true })
        // Map policy sets to the format expected by the component
        this.policyList = policySets.map((policySet) => ({
          id: policySet.id,
          name: policySet.name || 'Unnamed Policy Set',
          updatedAt: policySet.updated_at || policySet.created_at,
          active: policySet.active,
          scope: policySet.scope,
        }))
      } catch (error) {
        console.error('Error fetching policy sets:', error)
        this.$store.commit('application/openModal', {
          component: MODAL_ALERT,
          props: {
            title: 'Error',
            text: error.message || 'Failed to load policy sets',
            actionBtnLabel: 'OK',
            showCancelBtn: false,
          },
        })
        this.policyList = []
      } finally {
        this.loading = false
      }
    },
    formatDate(date) {
      return dayjs(date).format('D MMM YYYY hh:mm')
    },
    toPolicyDetail(policy) {
      this.$router.push({
        name: 'publisher_policy_detail',
        params: { policyId: policy.id },
      })
    },
  },
}
</script>

<style lang="scss" scoped>
$style: PolicyList;
.#{$style} {
  background: $N7;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  &__icon-button {
    background: $N5;
    height: 40px;
  }
  &__icon {
    color: $B1;
    fill: $B1;
  }
  .v-btn {
    display: block;
    margin-left: 10px;
  }
  .viewBtn {
    color: $B1;
    background: $N5;
  }
}

.spinner {
  display: flex;
  width: 100%;
  height: 100%;
  align-items: center;
  justify-content: center;
  min-height: 80vh;
}
</style>
